import { render, staticRenderFns } from "./CustomerTurnoverRelation.vue?vue&type=template&id=7521b092&scoped=true&"
import script from "./CustomerTurnoverRelation.vue?vue&type=script&lang=js&"
export * from "./CustomerTurnoverRelation.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTurnoverRelation.vue?vue&type=style&index=0&id=7521b092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7521b092",
  null
  
)

export default component.exports